import { RefObject, useState } from "react";
import Content from "../Content";
import TagIcon from "assets/icons/tagIcon";
import VLAccordian from "views/components/Accordian";
import ContentBodyLoader from "../Content/ContentBody/ContentBodyLoader";

import styles from "../style.module.scss";
import {
  FilterItemCountsWithSelect,
  RightPaneMetrics,
  SetStateFunction,
} from "types";

const LABEL_SECTION_ID = "labels-1";

interface LabelSectionProps {
  isLoading: boolean;
  labels: FilterItemCountsWithSelect[];
  sectionHeight: number | false;
  labelsRef: RefObject<HTMLDivElement>;
}

interface LabelSectionContentProps {
  labels: FilterItemCountsWithSelect[];
  selectedMetric: RightPaneMetrics;
  sectionHeight: number | false;
  isLoading: boolean;
}

interface MetadataSectionContentLabelsProps {
  labels: FilterItemCountsWithSelect[];
  selectedMetric: RightPaneMetrics;
  selectedID: string | null;
  isLoading: boolean;
  setSelectedID: SetStateFunction<string | null>;
}

function NoLabels() {
  return (
    <div className={styles.noDataWrapper}>
      <div className={styles.noData}>
        Currently no Label available in this cluster
      </div>
    </div>
  );
}

const MetadataSectionContentLabels = ({
  labels,
  isLoading,
  selectedID,
  selectedMetric,
  setSelectedID,
}: MetadataSectionContentLabelsProps) => {
  if (labels.length > 0) {
    return (
      <>
        <Content
          data={labels}
          id="labels-1"
          type="labels"
          title="Labels"
          sectionType="labels"
          isLoading={isLoading}
          selectedID={selectedID}
          selectedMetric={selectedMetric}
          setSelectedID={setSelectedID}
        />
      </>
    );
  } else {
    return <></>;
  }
};

const LabelSectionContent = ({
  labels,
  isLoading,
  sectionHeight,
  selectedMetric,
}: LabelSectionContentProps) => {
  const initialSelectedID = sectionHeight ? LABEL_SECTION_ID : null;
  const [selectedID, setSelectedID] = useState<string | null>(
    initialSelectedID,
  );

  return (
    <div
      className={styles.section}
      style={{ height: !!sectionHeight ? sectionHeight : "max-content" }}
    >
      <MetadataSectionContentLabels
        labels={labels}
        isLoading={isLoading}
        selectedID={selectedID}
        selectedMetric={selectedMetric}
        setSelectedID={setSelectedID}
      />
    </div>
  );
};

const LabelSection = ({
  labels,
  labelsRef,
  sectionHeight,
  isLoading,
}: LabelSectionProps) => {
  const [selectedMetric, setSelectedMetric] =
    useState<RightPaneMetrics>("COUNT");

  const onToggleMetrics = () => {
    setSelectedMetric(selectedMetric === "PERCENTAGE" ? "COUNT" : "PERCENTAGE");
  };

  const handleDisplay = () => {
    if (isLoading && !labels.length) {
      return (
        <div className={styles.loadingBox}>
          <ContentBodyLoader center />
        </div>
      );
    } else if (labels.length > 0) {
      return (
        <LabelSectionContent
          labels={labels}
          isLoading={isLoading}
          sectionHeight={sectionHeight}
          selectedMetric={selectedMetric}
        />
      );
    } else return <NoLabels />;
  };

  return (
    <div className={styles.metadataWrapper} ref={labelsRef}>
      <VLAccordian
        key="Labels"
        title="Labels"
        initiallyClosed
        icon={<TagIcon />}
        id={LABEL_SECTION_ID}
        inSearch={!!sectionHeight}
        allowResize={labels.length > 5}
        selectedMetric={selectedMetric}
        isLoading={isLoading && !!labels.length}
        onToggleMetrics={onToggleMetrics}
      >
        {handleDisplay()}
      </VLAccordian>
    </div>
  );
};
export default LabelSection;
